import {routes,asyncRoutes} from '../../router/index';
import {getApiList,setApiList,getMenuList,setMenuList} from "../../utils/permission";
import {menuAuthResource} from "../../api/login";
import {deepClone} from "../../utils/format";


/**
 *
 *
 * @param {any} asyncRouterMap
 * @param {any} menu
 * @returns
 */
function filterAsyncRouter(menu) {
  let ret=deepClone(asyncRoutes)
  let children=[]
  ret[0].children.forEach(ele=>{
    if(menu.indexOf(ele.name)!==-1 || (ele.meta&& ele.meta.hidden)){
      children.push(ele)
    }
  })

  ret[0].children=children

  if(ret[0].children.length){
    let vchildren=ret[0].children.filter(ele1=>{
      return  !ele1.hidden
    })
    if(vchildren.length){
     ret[0].redirect={name:vchildren[0].name}
    }
  }
  ret.push(  { path: '*', redirect: '/404' })

  return ret

}


const permission = {
    state: {
      routers: routes,  //渲染菜单
      addRouters: [],      //动态添加路由
      currentMenu:[],      //当前菜单
      menuList: getMenuList(),  //权限接口返回的menuList
      apiList: getApiList(),   //权限接口返回的apiList
    },
    mutations: {
      SET_ROUTERS:(state,data)=>{
        state.routers=data
      },
      SET_ADDROUTERS:(state,data)=>{
        state.addRouters=data
      },
      SET_MENULIST: (state, menuList) => {
        state.menuList = menuList
      },
      SET_APILIST: (state, apiList) => {
        state.apiList = apiList
      },
    },
    actions: {
      getAuthority({commit, state}) {
        return new Promise((resolve, reject) => {
          menuAuthResource().then(res => {

            if (!res.data) {
              return
            }
            if(!res.data.menuList|| res.data.menuList.length===0){
              reject('该用户没有任何权限！');
              return
            }
            commit('SET_MENULIST', res.data.menuList);
            commit('SET_APILIST', res.data.apiList);
            setMenuList(res.data.menuList);
            setApiList(res.data.apiList);
            resolve(res)
          }).catch(error => {
            reject(error)
          })

        })
      },

      //根据返回的权限值过滤路由
      GenerateRoutes({ commit }, data) {
        let a=filterAsyncRouter(data)
        let r=routes.concat(a)
        commit('SET_ROUTERS',r)
        commit('SET_ADDROUTERS',a)

      },
    }
  };

export default permission;

